// Detects build version changes and clears stale service worker runtime caches.
// __BUILD_VERSION__ is a compile-time constant injected by Vite's `define` —
// it changes every build, so a mismatch with the stored version means new content
// has been deployed and cached .md / .json responses are stale.

const STORAGE_KEY = `${__STORAGE_KEY_PREFIX__}-build-version`;

export async function checkBuildVersion(): Promise<void> {
  const currentVersion = __BUILD_VERSION__;

  try {
    const storedVersion = localStorage.getItem(STORAGE_KEY);

    if (storedVersion && storedVersion !== currentVersion) {
      // Build changed — purge runtime caches used by the service worker
      if ('caches' in window) {
        await Promise.all([
          caches.delete('article-cache'),
          caches.delete('preview-cache'),
          caches.delete('data-cache'),
          caches.delete('image-cache'),
        ]);
      }

      // Prompt service worker to check for an updated sw.js
      if ('serviceWorker' in navigator) {
        const reg = await navigator.serviceWorker.getRegistration();
        reg?.update();
      }
    }

    localStorage.setItem(STORAGE_KEY, currentVersion);
  } catch {
    // localStorage or cache API unavailable — continue without caching logic
  }
}
